import React from 'react';

/** Optional label above demo visuals (section copy lives in HomeSections). */
export function DemoChrome({ title, hint }) {
  if (!title && !hint) return null;

  return (
    <div className="mkt-demo-chrome">
      {title ? <p className="mkt-demo-chrome-title">{title}</p> : null}
      {hint ? <p className="mkt-demo-chrome-hint">{hint}</p> : null}
    </div>
  );
}

export function DemoStage({
  title,
  hint,
  children,
  className = '',
  visualClassName = '',
}) {
  const visualClasses = ['mkt-demo-visual', visualClassName].filter(Boolean).join(' ');
  const showChrome = Boolean(title || hint);

  return (
    <div className={`mkt-demo-stage ${className}`.trim()}>
      <div className="mkt-demo-stage-glow" aria-hidden />
      <div className="mkt-demo-stage-inner">
        {showChrome ? <DemoChrome title={title} hint={hint} /> : null}
        <div className={visualClasses}>{children}</div>
      </div>
    </div>
  );
}
